var exports = {
  "w": "x0a7806d5--b94cc2--loader",
  "Q": "x0a7806d5--b94cc2--content",
};

module.exports = exports;
